export const DESIGNER_REQUEST_TIMEOUT = 5000

let requestCancelVersion = 0
let requestControllers = []

export const getDesignerRequestVersion = () => requestCancelVersion

export const isDesignerRequestVersionActive = (version) =>
  version === requestCancelVersion

export const cancelDesignerRequests = () => {
  requestCancelVersion += 1
  requestControllers.forEach((controller) => {
    controller.abort()
  })
  requestControllers = []
  return requestCancelVersion
}

export const getRequestTimeout = (action = {}) => {
  let timeout = action.timeout
  if (timeout === undefined || timeout === null || timeout === '') {
    timeout = action.timeoutMs
  }
  if (timeout === undefined || timeout === null || timeout === '') {
    timeout = DESIGNER_REQUEST_TIMEOUT
  }
  timeout = Number(timeout)

  return timeout > 0 ? timeout : undefined
}

export const applyRequestTimeout = (config = {}, action = {}) => {
  let timeout = getRequestTimeout(action)
  if (!timeout) return config

  let timeoutConfig = config.timeout ? config : {
    ...config,
    timeout,
  }

  if (timeoutConfig.signal) return timeoutConfig

  if (typeof AbortController === 'undefined') return timeoutConfig

  let controller = new AbortController()
  requestControllers.push(controller)
  setTimeout(() => {
    controller.abort()
    requestControllers = requestControllers.filter((item) => item !== controller)
  }, timeout)

  return {
    ...timeoutConfig,
    signal: controller.signal,
  }
}

export const withRequestTimeout = (request, action = {}) => {
  let timeout = getRequestTimeout(action)
  if (!timeout) return request

  return new Promise((resolve, reject) => {
    let timer = setTimeout(() => {
      let error = new Error('Designer request timeout')
      error.code = 'ECONNABORTED'
      reject(error)
    }, timeout)

    request
      .then(resolve)
      .catch(reject)
      .finally(() => clearTimeout(timer))
  })
}
